// Implements a simple `requestIdleCallback` mechanism with
// a setTimeout fallback for non-supporting browsers

const onIdleCallback = (callback, timeout = 1000) => {
	if ('requestIdleCallback' in window) {
		return requestIdleCallback(callback, { timeout });
	}

	return callback();
};

export { onIdleCallback };
